const _serviceDependencies = ['$q', '$timeout', 'Util'];
let _requests;

/**
 * @ngdoc service
 * @name services.RequestHandler
 *
 * @description
 * This class is used to handle request errors
 */
class RequestHandler {

    /**
     * @param {any} $q
     * @param {any} $timeout
     * @param {any} Util
     */
    constructor($q, $timeout, Util) {

        this.$q = $q;
        this.$timeout = $timeout;
        this.Util = Util;
        _requests = [];

    }

    /**
     * @ngdoc function
     * @name services.RequestHandler#retry
     * @methodOf services.RequestHandler
     * @function
     *
     * @description
     * This method is used to retry a request in case we receive
     * http server errors or browser errors (500, 504, net::ERR_TIMED_OUT etc...)
     *
     * @param {Object} error Info about the error (url, status code, method etc...)
     */
    retry(error) {

        const requestDeferred = this.$q.defer();
        const retryTimer = 3000; // miliseconds
        const retryNumber = 3;
        const errorCode = error.status;
        const url = error.config && error.config.url;
        let requestCounter = 0;

        // get REST API resource from url e.g. /me, /devices, /app-integrations
        const urlRestResource = this.Util.getRestResourceFromUrl(url);

        // create request object with the resource from url
        const request = { restResource: urlRestResource };

        // push the request object in _requests array
        _requests.push(request);

        /* iterate through _requests array and count
           the requests for a specific resource from url */
        angular.forEach(_requests, (value) => {

            if (value.restResource === urlRestResource) {

                requestCounter += 1;

            }

        });

        /* if the number of requests for a specific resource is smaller
           or equal with the retryNumber, resolve the promise */
        if (requestCounter <= retryNumber &&
            (errorCode === 0 || errorCode === 504)) {

            this.$timeout(() => {

                requestDeferred.resolve();

            }, retryTimer);

        } else {

            /* if the number of requests for a specific resource is bigger
               than retryNumber, reject the promise.
               Here we also clear the list of requests for a specific resource
               in order to reactivate the retry system in case of
               another call made by application or user
            */
            angular.forEach(_requests, (value, key) => {

                if (value.restResource === urlRestResource) {

                    delete _requests[key];

                }

            });

            requestDeferred.reject();

        }

        return requestDeferred.promise;

    }

}

_serviceDependencies.push(RequestHandler);

angular.module('services')
    .service('RequestHandler', _serviceDependencies);



// WEBPACK FOOTER //
// ./scripts/services/requestHandler.js